module.exports = __webpack_public_path__ + "img/@tmp_course_thumbnail_05.58157fda.jpg";